<template>
  <div class="district-town-form">
    <BForm @submit.prevent="handleSubmit">
      <!-- 地区町名入力 -->
      <BFormGroup
        label="地区町名"
        label-for="district-town-name"
        :state="getFieldState('districtTownName')"
        :invalid-feedback="errors.districtTownName"
        class="mb-3"
      >
        <BFormInput
          id="district-town-name"
          v-model="localDistrictTownName"
          :state="getFieldState('districtTownName')"
          placeholder="例: 中央地区 中央1丁目"
        />
      </BFormGroup>

      <!-- 説明文 -->
      <div class="form-info mb-3">
        <small class="text-muted">
          <i class="bi bi-info-circle me-1"></i>
          地区名と町名を含めた完全な名称を入力してください。
        </small>
      </div>
    </BForm>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { BForm, BFormGroup, BFormInput } from 'bootstrap-vue-next'

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({
      districtTownName: ''
    })
  },
  errors: {
    type: Object,
    default: () => ({})
  },
  isEdit: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'submit'])

// ローカルstate（BFormInputはv-modelで繋ぎ、カーソルリセットを防ぐ）
const localDistrictTownName = ref(props.modelValue.districtTownName ?? '')

// 親からmodelValueが変わったときにローカルを同期
watch(() => props.modelValue.districtTownName, (newVal) => {
  if (newVal !== localDistrictTownName.value) {
    localDistrictTownName.value = newVal ?? ''
  }
})

// ローカルの変更を親に伝える
watch(localDistrictTownName, (newVal) => {
  emit('update:modelValue', { ...props.modelValue, districtTownName: newVal })
})

const getFieldState = (fieldName) => {
  if (props.errors[fieldName]) {
    return false
  }
  return null
}

const handleSubmit = () => {
  emit('submit')
}
</script>

<style scoped>
.district-town-form {
  padding: 0.5rem 0;
}

.form-info {
  background-color: #f8f9fa;
  border-left: 4px solid #007bff;
  padding: 0.75rem;
  border-radius: 0.25rem;
}

.form-info small {
  margin: 0;
  display: block;
}

/* フォームスタイルの調整 */
.form-group label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
}

.form-control {
  border-radius: 0.375rem;
  border: 1px solid #ced4da;
  padding: 0.75rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control.is-invalid {
  border-color: #dc3545;
}

.form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.invalid-feedback {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #dc3545;
}
</style>
